import { render, staticRenderFns } from "./AuthImage.vue?vue&type=template&id=5a6a142f"
import script from "./AuthImage.vue?vue&type=script&lang=ts"
export * from "./AuthImage.vue?vue&type=script&lang=ts"
import style0 from "./AuthImage.vue?vue&type=style&index=0&id=5a6a142f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports